import { render, staticRenderFns } from "./AddPopularButton.vue?vue&type=template&id=4827da5b&scoped=true"
import script from "./AddPopularButton.vue?vue&type=script&lang=js"
export * from "./AddPopularButton.vue?vue&type=script&lang=js"
import style0 from "./AddPopularButton.vue?vue&type=style&index=0&id=4827da5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4827da5b",
  null
  
)

export default component.exports